import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { getBlockUrl, name2url } from '@icms/core/resource/block/get-block-url';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { NCmsOutletBlock } from '../../outlet/block/cms-outlet-block.interface';
import { NCmsComponentContentBlock } from './cms-component-content-block.interface';

const PREFIX_REGEXP = new RegExp(getBlockUrl(NCmsOutletBlock.BLOCK_ID, NCmsComponentContentBlock.ID));

export const CMS_COMPONENT_CONTENT_BLOCK_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentContentBlock.ID,
    name: 'Content block',
    description: 'Embed a content block shared with other pages or areas',
    tags: ['block'],
    isAdvanced: true,
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IRelationField>{
            key: 'block',
            type: NICmsContentField.EFieldType.relation,
            title: 'Block',
            description: 'Please select a block to show',
            required: true,
            options: {
                title: 'Block',
                type: ICmsBlock.type,
                multiple: false,
                filter: (block: ICmsBlock) => !!block.data!.url.match(PREFIX_REGEXP),
                addNew: true,
                onBeforeSave: (model: ICmsBlock) => {
                    const name = `${NCmsComponentContentBlock.ID}_${name2url(model.data!.name)}`;
                    const url = getBlockUrl(NCmsOutletBlock.BLOCK_ID, name);

                    model.dataSetter({
                        ...model.data!,
                        url
                    });
                }
            }
        }
    ]
};
